// THE workspace voice — the ElevenLabs voice id every spoken reply of this
// workspace uses: `settings.voice.voiceId`, picked by a workspace admin on
// /admin/workspace-settings (the Voice card) and checked server-side against
// the account's voice list. ONE reader for both live speakers: the voice
// overlay (components/VoiceOverlay.js `ttsVoiceOf`) and the typed-answer
// reader (functions/speakReply.js).
//
// Read through THE accessor (`workspaceSettings`), so a record still in
// flight (list-shaped) yields no voice rather than a guess, and shape-checked
// so nothing but a plain ElevenLabs id can reach the TTS URL. `null` = the
// server's default voice. `this` is the calling element (el.call).
export const workspaceVoiceId = function workspaceVoiceId(root) {
  const el = this
  if (!el || typeof el.call !== 'function') return null
  const read = el.call('workspaceSettings', root)
  const voice = read && read.settings && read.settings.voice
  const id = voice && typeof voice.voiceId === 'string' ? voice.voiceId.trim() : ''
  return /^[A-Za-z0-9]{10,40}$/.test(id) ? id : null
}
